const setAppSpinnerVisible = (context, value) => {
  context.commit("SET_APP_SPINNER_VISIBLE", value);
};

export default {
  setAppSpinnerVisible
};
